export interface Role {
  name: string
}

export enum Roles {
  SYSTEM_ADMIN = 'SYSTEM_ADMIN',
  MERCHANT = 'MERCHANT',
}
